import { useLang } from '@/hooks/lang';
const { $t } = useLang( '@shining3d/app' );
import { $logout } from '@/assets/common/common';
export default [
	{
		path: '/info',
		name: 'info',
		component: () => import( '@shining3d/info-component/index.vue' ),
		meta: {
			sideList: [
				{ path: '/info/personalInfo', name: $t( 'personalInformation.side.info' ), icon: 'icon-gerenzhongxin' },
				{ path: '/info/accountPassword', name: $t( 'personalInformation.side.password' ), icon: 'icon-zhanghaomima' },
			]
		},
		children: [
			{
				path: '/info/personalInfo',
				name: 'personalInfo',
				component: () => import( '@shining3d/info-component/infoList/personal-info.vue' )
			},
			{
				path: '/info/accountPassword',
				name: 'accountPassword',
				component: () => import( '@shining3d/info-component/infoList/account-password.vue' ),
				meta: { logouts: $logout }
			},
		],
		redirect: '/info/personalInfo'
	}
];
